import { createTheme } from '@mui/material/styles';

// Create theme that completely disables text transformation
const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none' },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: { textTransform: 'none' },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { textTransform: 'none' },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: { textTransform: 'none' },
        secondary: { textTransform: 'none' },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: { textTransform: 'none' },
      },
    },
  },
});

export default theme;